interface IframeWrapperProps {
  expandedAssistant: boolean;
  allowAssistant: boolean;
  wsID: string;
  docName: string;
  docID: string;
  userLangauge: string;
  assistant: string;
}

export const IframeWrapper: React.FC<IframeWrapperProps> = ({
  expandedAssistant,
  allowAssistant,
  wsID,
  docName,
  docID,
  userLangauge,
  assistant,
}): JSX.Element => {
  return (
    <div
      style={{
        display: expandedAssistant && allowAssistant ? "block" : "none",
        opacity: expandedAssistant && allowAssistant ? 1 : 0,
        transition: "opacity 300ms",
      }}
    >
      <iframe
        style={{
          border: "none",
          height: "90vh",
        }}
        width="98%"
        src={`https://login-dev.teamsystemdigital.com/api/jump?serviceId=AI_ASSISTANT_APP&deepLink=${encodeURIComponent(
          `?workspaceID=${wsID}&documentName=${docName}&documentId=${docID}&userLanguage=${userLangauge}&assistant=${assistant}&embed=true`
        )}`}
        title="Documents"
      />
    </div>
  );
};
